/**
 * @generated SignedSource<<1624adc584f7cab0160a30197182c4de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RootQuery$variables = {};
export type RootQuery$data = {
  readonly music_viewer: {
    readonly account: {
      readonly on_waitlist: boolean;
    };
  };
};
export type RootQuery = {
  variables: RootQuery$variables;
  response: RootQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MusicViewer",
    "kind": "LinkedField",
    "name": "music_viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicAccount",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "on_waitlist",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RootQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RootQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "0ff60e2dc75aa5d6b6fc63da052d09ca",
    "id": null,
    "metadata": {},
    "name": "RootQuery",
    "operationKind": "query",
    "text": "query RootQuery {\n  music_viewer {\n    account {\n      on_waitlist\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f0a09bb45bb1a449328cee841fdc3c7a";

export default node;
